import { filter, includes } from "lodash";
import { useMilestones } from "@radarly/core/milestones/use-cases";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";

export function useContextualWorkspaceMilestones() {
  const workspace = useCurrentWorkspace();
  const milestones = useMilestones();
  return filter(milestones, (milestone) => {
    return includes(workspace?.milestones, milestone.id);
  });
}
